import {
    ChangeDetectorRef,
    Component,
    OnInit,
    inject,
  } from '@angular/core';

  import { DatePipe } from '@angular/common';
  import { FormsModule } from '@angular/forms';
  import { Router } from '@angular/router';
  import { TalkService } from '../../services/talk.service';
  import { PaginationComponent } from '../ui/pagination/pagination.component';
  
  
  @Component({
    selector: 'app-talk-list',
    templateUrl: './talk-list.html',
    styleUrl: './talk-list.scss',
    imports: [DatePipe, FormsModule, PaginationComponent],
  })
  export class TalkListComponent implements OnInit {
    private talkService = inject(TalkService);
    private cdr = inject(ChangeDetectorRef);
    private router = inject(Router);
  
    talks: any[] = [];
    page = 1;
    pageSize = 6;

    get pagedTalks(): any[] {
      const start = (this.page - 1) * this.pageSize;
      return this.talks.slice(start, start + this.pageSize);
    }

    isLoading = true;
    showCreateForm = false;
    isCreatingTalk = false;

    newTalk = {
    name: '',
    date: '',
    location: '',
    entrySurvey: false,
    exitSurvey: false,
    };
  
    ngOnInit(): void {
      this.loadTalks();
    }
  
    loadTalks(): void {
      this.isLoading = true;
  
      this.talkService.getAllTalks().subscribe({
        next: (response: any) => {
          console.log('🟢 PLÁTICAS RECIBIDAS:', response);
  
          this.talks = response.data.documents;
          this.isLoading = false;
  
          this.cdr.detectChanges();
        },
  
        error: (error) => {
          console.error(
            '🔴 ERROR CARGANDO PLÁTICAS:',
            error,
          );
  
          this.talks = [];
          this.isLoading = false;
  
          this.cdr.detectChanges();
        },
      });
    }

    viewTalk(id: string): void {
        this.router.navigate(['/admin/talks', id]);
      }

      copyFormLink(): void {
        const formUrl =
          `${window.location.origin}/formularios/platicas`;
      
        navigator.clipboard.writeText(formUrl).then(() => {
          alert('Formulario copiado correctamente');
        });
      }

    openCreateForm(): void {
        this.showCreateForm = true;
      }
      
    closeCreateForm(): void {
        this.showCreateForm = false;
      
        this.newTalk = {
          name: '',
          date: '',
          location: '',
          entrySurvey: false,
          exitSurvey: false,
        };
      }

      createTalk(): void {
        if (
          !this.newTalk.name ||
          !this.newTalk.date
        ) {
          return;
        }
      
        this.isCreatingTalk = true;
      
        this.talkService
          .createTalk(this.newTalk)
          .subscribe({
            next: (response: any) => {
              console.log(
                '🟢 PLÁTICA CREADA:',
                response,
              );
      
              const newTalk =
                response.data.document;
      
              this.talks = [
                newTalk,
                ...this.talks,
              ];
      
              this.isCreatingTalk = false;
      
              this.closeCreateForm();
      
              this.cdr.detectChanges();
            },
      
            error: (error) => {
              console.error(
                '🔴 ERROR CREANDO PLÁTICA:',
                error,
              );
      
              this.isCreatingTalk = false;
      
              this.cdr.detectChanges();
            },
          });
      }
  }